import React from 'react';
//import Scss
import './assets/scss/themes.scss';
//imoprt Route
import Route from './Routes';
import { CustomerCartProvider } from './contexts/CustomerCartContext';

function App() {
  return (
    <CustomerCartProvider>
      <Route />
    </CustomerCartProvider>
  );
}

export default App;
